import React from "react";
import SupportModal from "../Modal/SupportModal";

const HeadsetIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="currentColor"
    viewBox="0 0 16 16"
    style={{ verticalAlign: "middle", marginRight: "8px" }}
    aria-label="Support"
  >
    <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z" />
  </svg>
);

function SecondFooter() {
  const currentYear = new Date().getFullYear();
  const [supportShow, setSupportShow] = React.useState(false);

  return (
    <>
      <SupportModal show={supportShow} onHide={() => setSupportShow(false)} />

      {/* ── Support Strip ─────────────────────────────── */}
      <div className="footer-support-strip">
        <div className="container">
          <div className="row align-items-center justify-content-center text-center">
            <div className="col-lg-7">
              <p className="footer-support-text">
                Need help getting started? If something isn't working or you'd like assistance with
                registration, we're here to help — every step of the way.
              </p>
              <button className="footer-support-btn" onClick={() => setSupportShow(true)}>
                <HeadsetIcon />
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Main Footer ───────────────────────────────── */}
      <footer className="SecondFooter" style={{ backgroundColor: '#f8f9fa', paddingBottom: '24px' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="text-center mt-4 mb-3" style={{ fontSize: "18px" }}>
                © All rights reserved CANCER MANAGEMENT - {currentYear}
              </h4>
              <div className="text-center">
                <p className="mt-3 fw-bold">Partner with us to shape the future of cancer care.</p>
                <p className="mt-1">
                  Bring our advanced cancer management solutions to your patients.
                  Together, we can improve outcomes and save more lives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default SecondFooter;
